import React from 'react'
import StashfinFeaturesImage from "../../assets/images/features-stashfin.webp"
import StashfinBenefitImage from "../../assets/images/benefits-stashfin.webp"
import StashfinVectorImage from "../../assets/images/vector-stashfin.webp"
import { useSelector } from 'react-redux'

const FeaturesAndBenefits = () => {
  const { cityData } = useSelector(state => state.CityWiseIplReducer)
  return (
    <section id="features" className='features-and-benefits'>
      <div className='heading'>
        Why choose Stashfin <br /> personal loan in {cityData?.city}?
      </div>
      <div className='features-container'>
        <img className='features-img' src={StashfinFeaturesImage} alt="Features of Stashfin" loading='lazy' />
        <div className='features-heading'>
          Here are some attractive features of <br /> Stashfin personal loans:
        </div>
        <div className='feature-list'>
          <ul>
            <li>Get a credit limit upto <span>₹ 5,00,000</span></li>
            <li>Get <span> 0% interest </span> for up to 30 days.</li>
            <li>Select from Flexible Tenure Options upto <br /> <span>36 months</span></li>
            <li>Pay interest only on the <span> amount utilized</span></li>
            <li><span>Instant funds </span> for all your needs</li>
          </ul>
        </div>
      </div>
      <div className='heading'>
        How is Stashfin personal loan <br /> beneficial over other loans in {cityData?.city}?
      </div>
      <div className='benefits-container'>
        <img className='benefits-img' src={StashfinBenefitImage} alt="Features of Stashfin" loading='lazy' />
        <div className='benefits-heading'>
          Here are the advantages of <br />a Stashfin personal loan:
        </div>
        <div className='benefits-list'>
          <ul>
            <li><img src={StashfinVectorImage} alt="stashfin-benefits-vector" loading='lazy' />100% Paperless Application</li>
            <li><img src={StashfinVectorImage} alt="stashfin-benefits-vector" loading='lazy' />Easy 5 minutes application process.</li>
            <li><img src={StashfinVectorImage} alt="stashfin-benefits-vector" loading='lazy' />No questions asked on need</li>
            <li><img src={StashfinVectorImage} alt="stashfin-benefits-vector" loading='lazy' />Instant Amount Transfers</li>
            <li><img src={StashfinVectorImage} alt="stashfin-benefits-vector" loading='lazy' />No additional charges on foreclosure</li>
          </ul>
        </div>
      </div>
    </section>
  )
}
export default FeaturesAndBenefits
